export const directsendPushEn = {
  'directsend-push-heading': 'Send Funds',
  'directsend-push-add-contact-alert':
    'No Contacts found, please add a new contact to continue',
  'directsend-push-new-contact-button': 'Add Contact',
  'directsend-push-create-contact-heading': 'Add Contact',
  'directsend-push-update-contact-heading': 'Update Contact',
  'directsend-push-delete-heading': 'Delete Contact',
  'directsend-push-contact-name-input-label': 'External Account Name',
  'directsend-push-contact-full-cardholder-name-input-label':
    'Full Cardholder Name',
  'directsend-push-contact-card-number-input-label': 'Card Number',
  'directsend-push-contact-expiry-input-label': 'Expiry',
  'directsend-push-contact-cvv-input-label': 'CVV',
  'directsend-push-contact-address-line-one-input-label': 'Address Line 1',
  'directsend-push-contact-address-line-two-input-label': 'Address Line 2',
  'directsend-push-contact-city-input-label': 'City',
  'directsend-push-contact-state-input-label': 'Province/State',
  'directsend-push-contact-postal-code-input-label': 'Postal Code',
  'directsend-push-contact-country-input-label': 'Country',
  'directsend-push-create-contact': 'add Contact',
  'directsend-push-success-create-alert': 'Contact successfully added',
  'directsend-push-account-deleted-alert': 'Contact successfully deleted',
  'directsend-push-success-update-alert': 'Contact successfully updated',
  'directsend-push-form-title': 'Send Funds to my Card',
  'directsend-push-form-text': 'To External Contact with Debit Card',
  'directsend-push-delete-form-text':
    'Are you sure you want to delete your contact - {name} ?',
  'directsend-push-form-select-external-account-label':
    'Select a contact to send funds to',
  'directsend-push-amount-label': 'Amount',
  'directsend-push-exceeds-available-amount-alert':
    'Amount exceeds available balance',
  'directsend-push-transfer-created-alert': 'Funds sent successfully',
  'directsend-push-confirm-transfer-heading': 'Confirm Transfer',
  'directsend-push-message-label': 'Message',
  'directsend-push-confirm-transfer-message':
    'This transfer has a fee of ${feeAmount}. Do you wish to continue with this send request?', // eslint-disable-line no-template-curly-in-string
  'directsend-push-confirm-transfer-no-fee-message':
    'Do you wish to continue with this send request?',
};

export const directsendPushFr = {
  'directsend-push-heading': 'Envoyer des fonds',
  'directsend-push-add-contact-alert':
    'Aucun contact trouvé, veuillez ajouter un nouveau contact pour continuer',
  'directsend-push-new-contact-button': 'Ajouter un contact',
  'directsend-push-contact-name-input-label': 'Nom de compte externe',
  'directsend-push-contact-full-cardholder-name-input-label':
    'Nom complet du titulaire de la carte',
  'directsend-push-contact-card-number-input-label': 'Numéro de carte',
  'directsend-push-contact-expiry-input-label': 'Expiration',
  'directsend-push-contact-cvv-input-label': 'CVV',
  'directsend-push-contact-address-line-one-input-label': 'Adresse ligne 1',
  'directsend-push-contact-address-line-two-input-label': 'Adresse ligne 2',
  'directsend-push-contact-city-input-label': 'Ville',
  'directsend-push-contact-state-input-label': 'Province/État',
  'directsend-push-contact-postal-code-input-label': 'Code postal',
  'directsend-push-contact-country-input-label': 'Pays',
  'directsend-push-create-contact-heading': 'Ajouter un contact',
  'directsend-push-update-contact-heading': 'Mettre à jour le contact',
  'directsend-push-delete-heading': 'Supprimer le contact',
  'directsend-push-create-contact': 'Ajouter un contact',
  'directsend-push-success-create-alert': 'Contact ajouté avec succès',
  'directsend-push-account-deleted-alert': 'Contact supprimé avec succès',
  'directsend-push-success-update-alert': 'Contact mis à jour avec succès',
  'directsend-push-form-title': 'Envoyer des fonds à ma carte',
  'directsend-push-form-text':
    'Vers un contact externe avec Interac virement électronique',
  'directsend-push-delete-form-text':
    'Êtes-vous sûr de vouloir supprimer votre contact - {name} ?',
  'directsend-push-form-select-external-account-label':
    'Sélectionnez un contact à qui envoyer des fonds',
  'directsend-push-amount-label': 'Montant',
  'directsend-push-exceeds-available-amount-alert':
    'Le montant dépasse le solde disponible',
  'directsend-push-transfer-created-alert': 'Fonds envoyés avec succès',
  'directsend-push-confirm-transfer-heading': 'Confirmer le transfert',
  'directsend-push-message-label': 'Message',
  'directsend-push-confirm-transfer-message':
    'Ce virement comporte des frais de ${feeAmount}. Souhaitez-vous continuer avec cette demande d’envoi?', // eslint-disable-line no-template-curly-in-string
  'directsend-push-confirm-transfer-no-fee-message':
    'Souhaitez-vous continuer avec cette demande d’envoi?',
};
